import React from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';

function About(){
    return(
    <React.Fragment>
        <Container id="about" fluid className="dark container">
            <h1 className="text-center">About Me</h1>
            <hr/>
            <Row>
                <Col className="headline">
                    <p>I'm a 4rth year computer science student currently studying at<span className="bold"> Sinhgad Institute of Technology</span>,
                     Lonavala. I am currently working as a MERN stack frontend developer and i am full stack web devepment
                     enthusiast. 
                    </p>
                </Col>       
            </Row>
            <Row className="my-cards">
                <Col xs={12} md={4} className="justify-content-center">
                    <Card style={{ width: '20rem' }}>
                        <Card.Img variant="top" src="./images/travel.jpg" className="card-img" fluid/>
                        <Card.Body>
                            <Card.Title>Travelling</Card.Title>
                            <Card.Text>
                                I like the travelling on holidays.
                                I have visited more then 10 North, Western states & UTs and more then 30 cities.
                                Now my goal is to visit Southern and North-Eastern States in future.
                            </Card.Text>
                           { //<Button variant="primary">Go somewhere</Button>
                            }
                        </Card.Body>
                    </Card>
                </Col> 
                <Col xs={12} md={4} className="justify-content-center">
                    <Card style={{ width: '20rem' }}>
                        <Card.Img variant="top" src="./images/photography.jpeg" className="card-img" fluid />
                        <Card.Body>
                            <Card.Title>Photography</Card.Title>
                            <Card.Text>
                                My favourite hobby is to click images of various things around me.
                                Although i am far from the professional photography,
                                i have a good collection of stills clicked by me.
                                The above image is also clicked by me at Lion's Point, Lonavala. 
                            </Card.Text>
                           { //<Button variant="primary">Go somewhere</Button>
                            }
                        </Card.Body>
                    </Card>
                </Col>  
                <Col xs={12} md={4} className="justify-content-center">
                    <Card style={{ width: '20rem' }}>
                        <Card.Img variant="top" src="./images/music.jpg" className="card-img" fluid />
                        <Card.Body>
                            <Card.Title>Listening Songs</Card.Title>
                            <Card.Text>
                                Listening songs is great way to release stress.
                                I am a huge fan of bollywood songs.
                                I have several playlists for my diffrent swinging moods.
                                Be it early morning or late night, I am always ready for Songs.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>      
            </Row>
            <br></br>
            
        </Container>
    </React.Fragment>
    );

}

export default About;